export async function runRepair(actions, providers, concurrency, onProviderError) {
    const queue = [...actions];
    const workers = Array.from({ length: concurrency }, () => repairWorker(queue, providers, onProviderError));
    await Promise.all(workers);
}
async function repairWorker(queue, providers, onProviderError) {
    while (queue.length > 0) {
        const action = queue.shift();
        if (!action)
            return;
        const target = providers.find((p) => p.id === action.providerId);
        const source = providers.find((p) => p.id === action.sourceProviderId);
        if (!target || !source)
            continue;
        try {
            if (action.isTombstone && action.deletedAt) {
                await target.deleteRecord(action.namespace, action.key, action.deletedAt);
            }
            else {
                const rec = await source.getRecord(action.namespace, action.key);
                if (rec)
                    await target.putRecord(rec);
            }
        }
        catch (err) {
            onProviderError?.(target.id, 'read-repair', err);
        }
    }
}
//# sourceMappingURL=repair-runner.js.map